export default __webpack_public_path__ + "static/media/Fourth-man.d344e150.jpg";